import { useQueryVendorDetailHeader } from '../../models/useQueryVendorDetailHeader'

export interface IUseVendorDetailHeaderPresenterParams {
  /** Route param — the FS/Page owns routing context (ADR-9) */
  vendorId: number
  /** False when another report config's header hook should fetch instead */
  enabled?: boolean
}

/**
 * Hook-only presenter (ADR-2): resolves the vendor for the detail
 * breadcrumb "{Orders by vendor} / {vendor name}" independent of the
 * line-item fetch (BHV-022). Only `name` is consumed.
 */
export const useVendorDetailHeaderPresenter = ({
  vendorId,
  enabled = true,
}: IUseVendorDetailHeaderPresenterParams) => {
  const { vendor, isLoading } = useQueryVendorDetailHeader(vendorId, enabled)

  return {
    data: {
      vendorName: vendor?.name ?? null,
    },
    states: {
      isLoading,
    },
  }
}
